import { render, staticRenderFns } from "./updata.vue?vue&type=template&id=b0da5d62&scoped=true"
import script from "./updata.vue?vue&type=script&lang=js"
export * from "./updata.vue?vue&type=script&lang=js"
import style0 from "./updata.vue?vue&type=style&index=0&id=b0da5d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0da5d62",
  null
  
)

export default component.exports